import { create } from 'zustand';
import axios from 'axios';

const useEmployeeDataByIdStore = create((set) => ({
  employeeDataPerId: [], // Initialize as empty array instead of null
  loading: false,
  error: null,

  fetchEmployeeDataPerId: async (id, accessToken) => { 
    try {
      set({ loading: true, error: null }); 
      const timestamp = new Date().getTime();

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/employees/employeeInformation/${id}?timestamp=${timestamp}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const data = response.data?.data;
      set({ employeeDataPerId: data || [], loading: false }); // Fallback to empty array
      // console.log("employeeDataPerId", data);
    } catch (error) {
      console.error(error);
      set({ error, loading: false, employeeDataPerId: [] }); // Set to empty array on error
    }
  },

  resetEmployeeData: () => set({ employeeDataPerId: [], error: null }) // Reset to empty array
}));

export default useEmployeeDataByIdStore;